import React from "react";
import {connect, useSelector} from "react-redux";
import {general} from "../../../../../../store/action";
import Icon from "../../../../general/icon";
import {getCellValue} from "../../../../../../utils/utils";
import {Dispatch} from "redux";
import {monthDay, MtoJHHMMFormat, yearTitle} from "../../../../../../utils/date";
import Tooltip from "../../../../general/tooltip";
import {useFindAccessInAccessList} from "../../../../../../constants/constant/accessProcess";


type PatientBiometricCardsBoxItemProps = {
  item: any;
  dataListTitles: string[];
  handleShowModal: any;
  readonly?: boolean;
}

const PatientBiometricCardsBoxItem = ({
  item,
  dataListTitles,
  handleShowModal,
  readonly
}: PatientBiometricCardsBoxItemProps) => {
  const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
  const {findAccessInAccessList} = useFindAccessInAccessList();

  return (
    <div className="box-shadow rounded mb-4 px-4 py-3 mt-2 mx-2">
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="observationDateTime">{dataListTitles[0]}</label>
        <span className="mr-2">
          {
            getCellValue(monthDay(item?.observationDateTime)) + ' ' +
            getCellValue(yearTitle(item?.observationDateTime)) + ' - ' +
            getCellValue(MtoJHHMMFormat(item?.observationDateTime))
          }
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="weight">{dataListTitles[1]}</label>
        <span className="mr-2">{getCellValue(item?.weight?.magnitude)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="height">{dataListTitles[2]}</label>
        <span
          className="mr-2">{getCellValue(item?.height?.magnitude)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="bmi">{dataListTitles[3]}</label>
        <span className="mr-2">{getCellValue(item?.bmi?.magnitude)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="muac">{dataListTitles[4]}</label>
        <span className="mr-2">{getCellValue(item?.muac?.magnitude)}</span>
      </div>
      {
        ((!readonly && isProvider) || findAccessInAccessList('EHR_BIOMETRIC_DELETE')) &&
        <div className="d-flex align-items-center justify-content-between my-3">
          <label className="text-gray mb-0" htmlFor="actions">{dataListTitles[5]}</label>
          <div className="d-flex align-items-center justify-content-end my-3">
            <div className="d-flex align-items-center">
              <Tooltip alt={'حذف'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => handleShowModal('deletePatientBiometricModal', item?.id)}
                className="d-flex text-red-hover mx-2 font-20 cur-pointer"
              >
                <Icon name='trash'/>
              </span>
              </Tooltip>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PatientBiometricCardsBoxItem);